import { clsx } from "clsx";
import m from "mithril";
import { postVerifyRecoveryCode } from "./api/postVerifyRecoveryCode";
import { BlueBackground } from "./components/BlueBackground";
import { Checkbox } from "./components/Checkbox";
import { Copyright } from "./components/Copyright";
import { TinyLoadingAnimationCenter } from "./components/LoadingAnimation";
import { LogoSection } from "./components/LogoSection";
import { PrimaryButton } from "./components/PrimaryButton";
import { PhoneIcon } from "./components/SvgIcons";
import { Text } from "./components/Text";
import { TextField } from "./components/TextField";
import { TextLink } from "./components/TextLink";
import { onLoginSuccess } from "./utils/onLoginSuccess";
import { withRedirectUri } from "./utils/withRedirectUri";

let recoveryCode = "";
let isLoading = false;
let error = "";
let rememberMe = false;

const doVerify = async () => {
  try {
    isLoading = true;
    error = "";
    const result = await postVerifyRecoveryCode(recoveryCode, rememberMe);

    recoveryCode = "";
    onLoginSuccess(result);
  } catch (e: any) {
    error = "response" in e && "status" in e.response ? e.response.status : "Invalid credentials";
    // eslint-disable-next-line no-console
    console.log(e);
    isLoading = false;
  }
};

export const MFARecoveryPage: m.Component = {
  view() {
    return m(
      BlueBackground,
      m(LogoSection),
      m(
        "div.w-80.space-y-4.mx-auto",
        m("div.text-center", m(Text, { variant: "title" }, "Two-factor recovery")),
        m(
          "div.p-4.space-y-3",
          m("div.mx-auto.w-6.h-6", m(PhoneIcon)),
          m("div.text-center", m(Text, { variant: "subtitle" }, "Recovery code")),
          m(TextField, {
            value: recoveryCode,
            focus: true,
            placeholder: "XXXX-XXXX-XXXX-XXXX",
            autocomplete: "one-time-code",
            onValue(value) {
              recoveryCode = value;
            },
          }),
          error && m(Text, { variant: "error" }, error),
          m(Checkbox, {
            label: "remember me on this device",
            value: rememberMe,
            onValue(value) {
              rememberMe = value;
            },
          }),
          m(
            PrimaryButton,
            {
              disabled: !recoveryCode || isLoading,
              onclick() {
                doVerify();
              },
            },
            isLoading ? m(TinyLoadingAnimationCenter) : "Verify"
          ),
          m(
            Text,
            "If you are unable to access your mobile device, enter one of your recovery codes to verify your identity."
          )
        ),
        m(
          "div.p-4.space-y-3",
          m(Text, { variant: "label" }, "Don't have a recovery code?"),
          m(
            "ul.pl-4",
            m(
              "li.list-disc",
              m(
                TextLink,
                {
                  url: withRedirectUri("/auth/mfa"),
                },
                m("span", { class: clsx("text-sky-300", "hover:text-sky-400") }, "Use your authenticcation app")
              )
            )
          )
        )
      ),
      m("div.mt-6", m(Copyright))
    );
  },
};
